// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-66806612]{font-size:16px;font-weight:500;color:#186bfc;padding:32px 0 16px;width:100%}.h300[data-v-66806612]{height:300px}.w50[data-v-66806612]{width:50%}.w25[data-v-66806612]{width:25%}", ""]);
// Exports
module.exports = exports;
